import { defineStore } from "pinia";
import { allMenuItems } from "@/constants/menuItems";
import { useAuthStore } from "@/stores/auth";

export const useAppSidebarMenuStore = defineStore("appSidebarMenu", {
  state: () => ({
    menuItems: [] as {
      text?: string;
      is_header?: boolean;
      title?: string;
      url?: string;
      icon?: string;
    }[],
  }),
  actions: {
    setMenuItems() {
      try {
        const authStore = useAuthStore();
        const userPermissions = authStore.getUserPermissions;

        if (!userPermissions) {
          console.error("User permissions are undefined");
          return;
        }

        const filteredMenuItems = allMenuItems.filter((item) => {
          if (item.href === "pedido-interno")
            return userPermissions.permisoConsultaPedidoInterno === true;
          if (item.href === "inicio" && userPermissions.permisoConsultaInicio)
            return true;
          if (item.href === "agenda" && userPermissions.permisoConsultaAgenda)
            return true;
          if (
            item.href === "fichajes" &&
            userPermissions.permisoConsultaFichajes
          )
            return true;
          if (item.href === "gastos" && userPermissions.permisoConsultaGastos)
            return true;
          if (
            item.href === "clientes" &&
            userPermissions.permisoConsultaClientes
          )
            return true;
          if (item.href === "pedidos" && userPermissions.permisoConsultaPedidos)
            return true;
          if (
            item.href === "transporte" &&
            userPermissions.permisoConsultaTransporte
          )
            return true;
          if (
            item.href === "mensajeria" &&
            userPermissions.permisoConsultaMensajeria
          )
            return true;
          if (
            item.href === "gerencia" &&
            userPermissions.permisoConsultaGerencia
          )
            return true;
        });

        if (!Array.isArray(filteredMenuItems)) {
          console.error("Filtered menu items is not an array");
          return;
        }

        this.menuItems = [
          { text: "Navigation", is_header: false },
          ...filteredMenuItems.map((item) => ({
            title: item.nombre,
            url: item.href,
            icon: item.icon,
          })),
        ];
      } catch (error) {
        console.error("Error setting menu items:", error);
      }
    },
  },
  persist: true,
});
